import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

window.addEventListener('load', () => {
    const galleryContainer = document.querySelector('#aanbod-gallery');
    if (!galleryContainer) return;

    const children = Array.from(galleryContainer.querySelectorAll<HTMLAnchorElement>('a'));

    const sortedChildren = children.sort(
        (a, b) => Number(a.dataset.index) - Number(b.dataset.index)
    );

    const lightbox = new PhotoSwipeLightbox({
        gallery: '#aanbod-gallery',
        wheelToZoom: true,
        children: sortedChildren,
        initialZoomLevel: "fit",
        pswpModule: () => import('photoswipe'),
        closeOnVerticalDrag: true,
        paddingFn: (viewportSize) => {
            return {
                top: viewportSize.y * 0.1,
                right: viewportSize.x * 0.1,
                bottom: viewportSize.y * 0.1,
                left: viewportSize.x * 0.1
            };
        },
    });

    lightbox.addFilter('itemData', (itemData, index) => {
        const iframeurl = itemData.element.dataset.pswpIframeUrl;
        if (iframeurl) {
            itemData.iframeUrl = iframeurl;
        }
        return itemData;
    });

    // override slide content
    lightbox.on('contentLoad', (e) => {
        const {content} = e;
        if (content.type === 'iframe') {
            // prevent the deafult behavior
            e.preventDefault();

            // Create a container for iframe
            // and assign it to the `content.element` property
            content.element = document.createElement('div');
            content.element.className = 'pswp__iframe-container';

            const iframe = document.createElement('iframe');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
            iframe.src = content.data.iframeUrl || '';
            content.element.appendChild(iframe);
        }
    });

    lightbox.init();
});
